import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, ListGroup, ListGroupItem, Badge } from 'reactstrap';

const ModalUserClassrooms = ({ isOpen, toggle, userClassrooms, userName }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="md">
      <ModalHeader toggle={toggle}>
        Turmas de {userName}
        <span className="ml-2 text-muted" style={{ fontSize: '0.9rem' }}>
          ({(userClassrooms || []).length} turmas)
        </span>
      </ModalHeader>
      <ModalBody>
        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          <ListGroup flush>
            {(userClassrooms || []).length > 0 ? (
              userClassrooms.map(cl => (
                <ListGroupItem key={cl.id} className="d-flex justify-content-between align-items-center">
                  <span style={{ fontSize: '0.8rem', fontWeight: 500 }}>
                    {cl.name}
                  </span>
                  <Badge color="primary" pill style={{ fontSize: '0.8rem', padding: '0.4em 0.75em' }}>
                    ID: {cl.id}
                  </Badge>
                </ListGroupItem>
              ))
            ) : (
              <p className="text-muted mb-0">Nenhuma turma encontrada.</p>
            )}
          </ListGroup>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Fechar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalUserClassrooms;